// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"68e8d2ce","265":"ab45dcd5","270":"84ac8fc0"}[chunkId] + ".chunk.js";
};